module.exports = __webpack_public_path__ + "img/philippe.36d748e3.png";